import { JsxPluginParams } from "@mdxeditor/editor";
import { MapEditor } from "./mapa";
import { ChartEditor } from "./chart";

export const jsxComponentPlugin: JsxPluginParams = {
  jsxComponentDescriptors: [
    {
      name: 'Chart',
      kind: 'flow',
      props: [
        { name: 'chartData', type: 'string' },
      ],
      hasChildren: false,
      Editor: ChartEditor,
    },
    {
      name: 'MapEditor',
      kind: 'flow',
      props: [
        { name: 'mapData', type: 'string' },
      ],
      hasChildren: false,
      Editor: MapEditor,
    },
  ]
};